const global = require('../../../Scripts/globalMU').default

ko.bindingHandlers.form = {
    init: function(element, valueAccessor, allBindingsAccessor) {
        var config = valueAccessor();

        if (!config) {
            return;
        }

        var formConfig = $.extend({ element: element, rules: {}, messages: {} }, config);


        $("[form-data]", $(element))
            .each(function() {

                var elementName = $(this).attr("Name");
                var formConfigAttr = $(this).attr("form-data");

                if (!elementName || !formConfigAttr) {
                    return;
                }

                try {
                    var formElementConfig = eval("({" + formConfigAttr + "})");

                    if (formElementConfig.rules) {
                        formConfig.rules[elementName] = formElementConfig.rules;
                    }

                    if (formElementConfig.messages) {
                        formConfig.messages[elementName] = formElementConfig.messages;
                    }

                } catch (e) {
                }
            });

        global.configForm(formConfig);


    }
};